module.exports = __webpack_public_path__ + "img/homem-andando (2).800d2059.png";